import Vue from 'vue'
import iView from 'iview'
import VueRouter from 'vue-router'
import {routers} from '../router/route'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

// 路由配置
const RouterConfig = {
  // base:'/app',
  routes: routers
}

export const router = new VueRouter(RouterConfig)
export function resetRouter() {
  router.matcher = new VueRouter().matcher
}

router.beforeEach((to, from, next) => {
  if(to.path=="/big" && from.path=="/"){
    iView.Spin.show();
  }
  
  if (Array.isArray(to.meta)) {
    iView.LoadingBar.start()
    next()
  }
 
})
router.afterEach((to) => {
  iView.LoadingBar.finish()
  iView.Spin.hide();
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/router/index.js